import {default as app} from '@legacy/App';


app.constant('version', {
        BuildVersionFull: '2.6.0',
        BuildDescription: 'No build description provided'
});
